import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();

useLayoutEffect(() => {
  if (navType !== 'POP') {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0; // body is the scroll container in this app
  }
}, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default ScrollToTop;

// import { useEffect } from 'react';

// import { useLocation } from 'react-router-dom';

// const ScrollToTop = () => {
//   const { pathname } = useLocation();

//   // Scroll to top on any router transition
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   return null;
// };

// export default ScrollToTop;
